export default __webpack_public_path__ + "static/media/12.1b8ecb2e.png";